
  export const shallowCompare = (obj1:any, obj2:any) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (let key of keys1) {
        if (key === "rejectType" || key === "quality_EmpId") {
            continue;
        }
        
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }
    
    return true;
}

export const defaultRow: any = [{
  sDefect_SF: 0,
  sDefect_EF: 0,
  sDefect_TF: 0,
  defects_Type: "",
  position: "",
  severity: "",
  quality_EmpId:'',
  rejectType:"",
  qcRemarks:''
}];
interface PreviousOwner {
  previous_Owner_EmployeeID: string;
  previous_Owner_Name: string;
}

export interface  qtSubtaskTypes{
    id: string;
    itemid: string;
    title_Code: string;
    reel_Name: string;
    resolution: string;
    start_Number: number;
    end_Number: number;
    total_Number: number;
    team: string;
    current_SubTask: string;
    title_Status: string;
    status: string;
    locked_By: string;
    previousOwner: PreviousOwner;
    input_Path: string;
    output_Path: string;
}

export const initialqtSubtaskTypes: qtSubtaskTypes = {
    id: "",
    itemid: "",
    title_Code: "",
    reel_Name: "",
    resolution: "",
    start_Number: 0,
    end_Number: 0,
    total_Number: 0,
    team: "",
    current_SubTask: "",
    title_Status: "",
    status: "",
    locked_By: "",
    previousOwner: {
      previous_Owner_EmployeeID: "",
      previous_Owner_Name: ""
    },
    input_Path: "",
    output_Path: ""
};
export const uniqByKeepLast =  (data: string[]) => {
    const uniqueMap: {
      [key: string]: { value: string; key: string; text: string };
    } = {};

    // Iterate over the array in reverse to keep the last occurrences
    for (let i = data.length - 1; i >= 0; i--) {
      const d = data[i];
      uniqueMap[d] = {
        value: d,
        key: d,
        text: d,
      };
    }
    const uniqueValues = Object.values(uniqueMap).sort((a, b) =>
      a.value.localeCompare(b.value),
    );

    return uniqueValues;
  }